<template>
	<v-card class="elevation-0" >
		<v-row>
			<v-col cols="12" class="px-8">
				<v-card class="shadowCard">
				  <v-card-title primary-title class="subtitle-1">
				    <b>Datos del alumno</b>
				  </v-card-title>
				  <v-card-text class="black--text">

				  	<b>Matricula:</b> {{ alumno.matricula }}
				  	<br/>
				  	<b>Nombre:</b> {{ alumno.nombre }}

				  	<v-divider class="my-2"></v-divider>

				  	<!-- TIPO DE ALUMNOS -->
				  	<label >Estatus del alumno actualmente</label>
				  	<br/>
		        <span v-if="grupo && grupo.tipoAlumno == 1"                     ><b>ALUMNO NI                      </b></span>
	          <span v-if="grupo && grupo.tipoAlumno == 2"                     ><b>ALUMNO REGULAR                 </b></span>
	          <span v-if="grupo && grupo.tipoAlumno == 3" class="orange--text"><b>ALUMNO IRREGULAR               </b></span>
	          <span v-if="grupo && grupo.tipoAlumno == 4" class="red--text"   ><b>ALUMNO CON ADEUDO              </b></span>
	          <span v-if="grupo && grupo.tipoAlumno == 5"                     ><b>ALUMNO PENDIENTE DE ABRIR GRUPO</b></span>
	          <span v-if="grupo && grupo.tipoAlumno == 6" class="red--text"   ><b>ALUMNO CON DIFERENCIA DE PAGO  </b></span>

				  </v-card-text>
				</v-card>
			</v-col>

			<!-- Aquí hay que poner algo para los que son de tipo 06 -->
      <v-col cols="12" v-if="grupo && [6].includes(grupo.tipoAlumno) " class="px-8">
        <v-card class="shadowCard">
          <v-card-title primary-title class="subtitle-1">
            <strong>GRUPO:</strong> {{ grupo.getUltimoGrupoPagado.grupo }}
          </v-card-title>
          <v-card-text class="black--text">
            <strong>DIFERENCIA:</strong> $ {{ grupo.getUltimoGrupoPagado.diferencia }}
          <br/>
          <br/>

          <v-alert
            dense
            outlined
            type="error"
          >
            {{ grupo.message }}
          </v-alert>
          </v-card-text>
        </v-card>
      </v-col>


      <!-- grupos Alumno unico -->
		  <v-col cols="12" v-if="grupo && [2,4,5].includes(grupo.tipoAlumno)" class="px-8">
		  	<v-card class="shadowCard">
		  	  <v-card-title primary-title class="subtitle-1">
            <b>Grupo Actual del alumno</b>
          </v-card-title>
		  	  <v-card-text class="black--text">
				  	<div class="text-subtitle-1">
				  		{{ grupo.grupoActual.grupo }}
				  		<br/>
		          <strong class="red--text">Adeudo: $ {{ grupo.grupoActual.adeudo }}<br/></strong>
				  	</div>
		  	  </v-card-text>
		  	  <v-card-actions v-if="grupo.grupoActual.adeudo <= 0">
            <v-tooltip bottom color="blue" max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="green"
                  dark
                  small
                  @click="steppers.grupo = grupo, steppers.factura = true, steppers.app = false, steppers.paso = 3"
                  tile
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small left>mdi-cash</v-icon>
                  Pagar Factura
                </v-btn>
              </template>
              <span>Procesar el pago de la factura del grupo actual</span>
            </v-tooltip>

            <!--<v-tooltip bottom color="blue" max-width="300" v-if="mostrarPagarApp">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="orange"
                  dark
                  small
                  class="ml-2"
                  @click="steppers.grupo = grupo, steppers.app = true, steppers.factura = false, steppers.paso = 3"
                  tile
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small left>mdi-cellphone-link</v-icon>
                  Pagar App
                </v-btn>
              </template>
              <span>Cobrar el bono IA + APP ($ 299) del grupo actual</span>
            </v-tooltip>-->
		  	  </v-card-actions>
		  	</v-card>
		  </v-col>

		  <v-col cols="12" v-if="errorMensaje" class="px-8">
		  	<v-alert
		      dense
		      outlined
		      type="error"
		    >
		      {{ errorMensaje }}
		    </v-alert>
		  </v-col>

      <!-- Alumnos DONDE EL GRUPO SE CERRÓ O NO TIENE CUPO SU GRUPO -->
      <!-- SELECCIONAR UN GRUPO DIFERENTE -->
      <v-col cols="12" v-if="!grupo" class="px-8">
        <v-card class="shadowCard">
          <v-card-title primary-title class="subtitle-1">
            Selecciona un nuevo grupo para el alumno
          </v-card-title>
          <v-card-text>
            <v-tooltip bottom color="blue" max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-autocomplete
                  label="Grupos"
                  dense
                  v-model="alumno.grupo"
                  :items="grupos"
                  item-text="grupo"
                  item-value="id_grupo"
                  clearable
                  filled
                  return-object
                  v-bind="attrs"
                  v-on="on"
                ></v-autocomplete>
              </template>
              <span>Selecciona un grupo nuevo (el anterior se cerró o no tiene cupo)</span>
            </v-tooltip>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Alumnos de reingreso -->
		  <!-- SELECCIONAR UN GRUPO DIFERENTE -->
      <v-col cols="12" v-if="grupo && [3].includes(grupo.tipoAlumno)" class="px-8">
        <v-card class="shadowCard">
          <v-card-title primary-title class="subtitle-1">
            Selecciona un nuevo grupo para el alumno
          </v-card-title>
          <v-card-text>
            <v-tooltip bottom color="blue" max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-autocomplete
                  label="Grupos"
                  dense
                  v-model="alumno.grupo"
                  :items="grupos"
                  item-text="grupo"
                  item-value="id_grupo"
                  clearable
                  filled
                  return-object
                  v-bind="attrs"
                  v-on="on"
                ></v-autocomplete>
              </template>
              <span>Selecciona el grupo para reinscribir al alumno irregular</span>
            </v-tooltip>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- ALUMNO RI REGUALAR -->
      <!-- Seleccionar otro grupo, alumnos NO HERMANOS -->
      <v-col cols="12" v-if="grupo && [2,4,5].includes(grupo.tipoAlumno) || grupo && [2,4,5].includes(grupo.tipoAlumno)" class="px-8">
        <v-card class="shadowCard">
          <v-card-title primary-title class="subtitle-1">
            <b>{{ tieneAdeudo ? 'Grupo de Cambio:' : 'Grupo siguiente:' }}</b>
          </v-card-title>
          <v-card-text class="black--text">
            <!-- Seleccionar otro grupo diferente al siguiente -->
            <v-tooltip bottom color="blue" max-width="300" v-if="otroGrupo">
              <template v-slot:activator="{ on, attrs }">
                <v-autocomplete
                  label="Selecciona un grupo"
                  dense
                  v-model="alumno.grupo"
                  :items="grupos"
                  item-text="grupo"
                  item-value="id_grupo"
                  clearable
                  filled
                  return-object
                  v-bind="attrs"
                  v-on="on"
                  :no-data-text="mensajeSinGruposCambio"
                ></v-autocomplete>
              </template>
              <span v-if="tieneAdeudo">Selecciona un grupo del ciclo de cambios (CAMBIOS)</span>
              <span v-else>Selecciona el grupo al que deseas reinscribir al alumno</span>
            </v-tooltip>

            <v-alert
              v-if="tieneAdeudo && otroGrupo && !cargar && grupos.length === 0"
              dense
              outlined
              type="warning"
              class="mt-3"
            >
              No hay grupos del ciclo de cambios disponibles para este periodo.
              Solicita a administración que abra un grupo de cambio (CAMBIOS).
            </v-alert>

            <div class="text-subtitle-1" v-if="tieneAdeudo ? grupo.grupoActual : grupo.grupoSiguiente">
              <span v-if="!otroGrupo">{{ textoGrupoCambio }}</span>
              <span v-if="grupo.capacidad">El siguiente grupo no cuenta con capacidad para inscribir alumnos</span>
              <v-tooltip bottom color="blue" max-width="300">
                <template v-slot:activator="{ on, attrs }">
                  <v-switch :label="tieneAdeudo ? 'Activar grupos de Cambio' : 'Seleccionar otro grupo'" v-model="otroGrupo" hide-details v-bind="attrs" v-on="on"></v-switch>
                </template>
                <span v-if="tieneAdeudo">Solo se muestran grupos del ciclo de cambios (CAMBIOS)</span>
                <span v-else>Activa esta opción si deseas elegir un grupo diferente al sugerido</span>
              </v-tooltip>
            </div>

            <div class="text-subtitle-1" v-if="!grupo.grupoSiguiente">
              <strong>{{ errorMensaje }}
                <br/>
              </strong>
              <span v-if="!otroGrupo"></span>
              <v-tooltip bottom color="blue" max-width="300">
                <template v-slot:activator="{ on, attrs }">
                  <v-switch :label="tieneAdeudo ? 'Activar grupos de Cambio' : 'Seleccionar otro grupo'" v-model="otroGrupo" hide-details v-bind="attrs" v-on="on"></v-switch>
                </template>
                <span v-if="tieneAdeudo">Activa para ver los grupos del ciclo de cambios (CAMBIOS)</span>
                <span v-else>Activa esta opción para seleccionar un grupo manualmente</span>
              </v-tooltip>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

		</v-row>

		<v-divider class="my-4"></v-divider>

		<v-card-actions>
      <v-tooltip bottom color="blue" max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            @click="dialogAddAlumno.estatus = false"
            v-bind="attrs"
            v-on="on"
          >
            Cancelar
          </v-btn>
        </template>
        <span>Cerrar y cancelar el proceso de reinscripción</span>
      </v-tooltip>

      <v-tooltip bottom color="blue" max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            tile
            color="primary"
            class="ml-2"
            @click="steppers.paso = 1"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon left small>mdi-arrow-left</v-icon>
            Regresar
          </v-btn>
        </template>
        <span>Volver al paso anterior</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom color="blue" max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
          	tile
            color="primary"
            @click="steppers.paso = 3"
            v-bind="attrs"
            v-on="on"
          >
            Siguiente
          	<v-icon right small>mdi-arrow-right</v-icon>
          </v-btn>
        </template>
        <span>Continuar al paso de realizar pago</span>
      </v-tooltip>
  	</v-card-actions>


  	<!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

    <AgregarProspecto     v-if="existeProspecto"             :parametrosProspectos="parametrosProspectos" @saveProspecto="saveProspecto"/>


	</v-card>
</template>
<script>
import axios from 'axios';
	import { mapGetters, mapActions } from 'vuex'
  import Alerta          from '@/components/alertas/Alerta.vue'
  import carga           from '@/components/alertas/carga.vue';

  import AgregarProspecto   from '@/components/inscripciones/AgregarProspecto.vue';


  import validarErrores  from '@/mixins/validarErrores'

	// Componentes
  export default {
  	components:{
      Alerta,
      carga,
      AgregarProspecto
    },

    mixins: [ validarErrores ],

  	props:[
			'alumno',
			'steppers',
			'hermanos',
			'tutor'
	  ],

    data: () => ({
    	escuela: 2,
			// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      cargar: false,

    	prospectos:[],
    	parametrosProspectos:{
    		estatus: false
    	},

    	existeProspecto:false,
    	prospecto: null,
    	grupos:[],

    	grupo: null,
    	errorMensaje:null,
      otroGrupo: false,
      nuevoGrupoSeleccionado:null

    }),

    computed: {
    	...mapGetters('login',['getdatosUsuarioERPERP', 'getEscuela']),

      /** Solo si no hay adeudo y aún no compró el bono IA + APP. */
      mostrarPagarApp () {
        const actual = this.grupo && this.grupo.grupoActual
        if ( !actual ) return false
        const sinAdeudo = Number( actual.adeudo ) <= 0
        const sinApp = Number( actual.bono_ia_app_sn ) !== 1
        return sinAdeudo && sinApp
      },

      tieneAdeudo () {
        if ( !this.grupo ) return false
        if ( Number( this.grupo.tipoAlumno ) === 4 ) return true
        const actual = this.grupo.grupoActual
        return actual && Number( actual.adeudo ) > 0
      },

      mensajeSinGruposCambio () {
        if ( this.tieneAdeudo ) {
          return 'Solicita a administración abrir un grupo de cambio (CAMBIOS)'
        }
        return 'No hay datos disponibles'
      },

      textoGrupoCambio () {
        if ( !this.grupo ) return ''
        if ( this.tieneAdeudo && this.grupo.grupoActual ) {
          return this.grupo.grupoActual.grupo
        }
        return this.grupo.grupoSiguiente ? this.grupo.grupoSiguiente.grupo : ''
      },
    },

    watch:{
      otroGrupo ( val ) {
        if ( val ) {
          if ( this.tieneAdeudo ) {
            this.getGruposCambio()
          } else {
            this.getGruposDisponibles()
          }
        }
      },
    },

    async created () {
    	this.escuela = this.getEscuela
    	await this.getGruposAlumno( )
    	if ( !this.tieneAdeudo ) {
    	  await this.getGruposDisponibles( )
    	}
    },

    methods: {

    	async getGruposAlumno( ) {
      	this.cargar = true

      	const payload = {
      		id_alumno: this.alumno.id_alumno,
      		escuela  : this.alumno.unidad_negocio
      	}

        try {
          await this.$http.post('inscripciones.grupo.alumno', payload).then(response=>{

            console.log( response.data )
          	this.cargar = false
          	this.grupo = response.data

          	this.alumno.tipoAlumno = this.grupo.tipoAlumno

            if( this.grupo && ![2,4].includes(this.grupo.tipoAlumno)){
              this.getGruposDisponibles( )
            }

            this.alumno.grupo = this.tieneAdeudo && this.grupo.grupoActual
              ? this.grupo.grupoActual
              : this.grupo.grupoSiguiente

          }).catch( error =>{

            if( error.response.data.grupoActual ){

              this.grupo = error.response.data
              this.alumno.tipoAlumno = this.grupo.tipoAlumno
              console.log( this.alumno.tipoAlumno ,'tipo de alumno')

            }else{

            }

            if( error.response.data.tipoAlumno ){
              this.alumno.tipoAlumno = error.response.data.tipoAlumno

            }

            this.errorMensaje = error.response.data.message
            this.validarError( error.response.data.message )

          }).finally( () => { this.cargar = false })
        }catch ( error ){
          console.log( error )
        }
      },

      marcarTipoAlumnoEnGrupos ( grupos, tipoAlumno ) {
        for ( const i in grupos ) {
          grupos[i]['tipoAlumno'] = tipoAlumno
        }
      },

      getGruposDisponibles( ) {
        this.cargar = true
        this.grupos = []

        return this.$http.get('grupos.disponibles/' + this.alumno.unidad_negocio ).then(response=>{
          this.grupos = response.data
          if ( this.grupo ) {
            this.marcarTipoAlumnoEnGrupos( this.grupos, this.grupo.tipoAlumno )
          }
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getPeriodoCiclo ( grupoTexto ) {
        const match = ( grupoTexto || '' ).match( /(\d{2}_\d{2})/ )
        return match ? match[1] : null
      },

      periodoCambioAdeudo ( data ) {
        if ( !data ) return null
        if ( data.cicloActual && data.cicloActual.ciclo ) {
          const periodoActivo = this.getPeriodoCiclo( data.cicloActual.ciclo )
          if ( periodoActivo ) return periodoActivo
        }
        const actual = data.grupoActual
        if ( actual ) {
          const periodoActual = this.getPeriodoCiclo( actual.ciclo ) || this.getPeriodoCiclo( actual.grupo )
          if ( periodoActual ) return periodoActual
        }
        return null
      },

      filtrarGruposCambio ( lista, periodo ) {
        if ( !lista || !lista.length ) return []
        return lista.filter( el => {
          const ciclo = ( el.ciclo || '' ).toUpperCase()
          const grupo = ( el.grupo || '' ).toUpperCase()
          const esCambios = ciclo.indexOf( 'CAMBIOS' ) >= 0 || grupo.indexOf( 'CAMBIOS' ) >= 0
          if ( !esCambios ) return false
          if ( periodo ) {
            return ciclo.indexOf( periodo ) >= 0 || grupo.indexOf( periodo ) >= 0
          }
          return true
        })
      },

      getGruposCambio () {
        if ( !this.grupo || !this.grupo.grupoActual ) return

        this.cargar = true
        this.grupos = []

        const periodo = this.periodoCambioAdeudo( this.grupo )

        return this.$http.get('grupos.disponibles/' + this.alumno.unidad_negocio ).then(response=>{
          this.grupos = this.filtrarGruposCambio( response.data, periodo )
          this.marcarTipoAlumnoEnGrupos( this.grupos, this.grupo.tipoAlumno )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

    },
  }
</script>
